import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Info } from "lucide-react";
import { api, formatError } from "@/lib/api";

export const Field = ({ id, label, hint, children }) => (
  <div>
    <label htmlFor={id} className="field-label">{label}</label>
    {hint && <p id={`${id}-hint`} className="text-sm text-ink-muted -mt-0.5 mb-1.5">{hint}</p>}
    {children}
  </div>
);

export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" className="absolute -left-[9999px] h-0 w-0 overflow-hidden">
    <label htmlFor="company_website">Leave this field empty</label>
    <input id="company_website" name="company_website" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
  </div>
);

export const Consent = ({ checked, onChange, testId }) => (
  <label className="flex items-start gap-3 text-[0.95rem] text-ink-soft cursor-pointer">
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 h-5 w-5 accent-[#2F6B6A] shrink-0" data-testid={testId} required />
    <span>I have read the <Link to="/privacy" className="btn-ghost !inline">privacy notice</Link> and agree to Addiction &amp; Us storing these details to respond to my message.</span>
  </label>
);

export const FormNotice = ({ children }) => (
  <div className="flex gap-3 rounded-2xl bg-clay-light border border-clay/20 p-4 text-[0.95rem] text-ink" role="note">
    <Info className="h-5 w-5 text-clay-dark shrink-0 mt-0.5" aria-hidden="true" />
    <div>{children}</div>
  </div>
);

export const FormSuccess = ({ title, children, testId }) => (
  <div className="card-soft p-8 flex gap-4 items-start" role="status" data-testid={testId}>
    <CheckCircle2 className="h-7 w-7 text-teal shrink-0" aria-hidden="true" />
    <div><h3 className="text-2xl">{title}</h3><p className="mt-2 text-ink-soft">{children}</p></div>
  </div>
);

export function useFormSubmit(endpoint, initial) {
  const [values, setValues] = useState(initial);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const set = (k) => (v) => setValues((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));
  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    try {
      await api.post(endpoint, values);
      setStatus("sent");
    } catch (err) {
      setError(formatError(err));
      setStatus("idle");
    }
  };
  return { values, set, submit, status, error };
}
